import React, { Component, createRef } from "react";

class DicomViewer extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = createRef();
    this.imageRef = createRef();
    this.state = {
      isDrawing: false,
      drawMode: false,
    };
  }

  componentDidMount() {
    this.updateCanvas();
    window.addEventListener("resize", this.updateCanvas);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.dicomImageSrc !== this.props.dicomImageSrc ||
      prevState.drawMode !== this.state.drawMode
    ) {
      this.updateCanvas();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateCanvas);
  }

  updateCanvas = () => {
    const canvas = this.canvasRef.current;
    const image = this.imageRef.current;

    if (!canvas || !image) return;

    canvas.width = image.clientWidth;
    canvas.height = image.clientHeight;
    canvas.style.position = "absolute";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.pointerEvents = this.state.drawMode ? "auto" : "none";

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  startDraw = (e) => {
    if (!this.state.drawMode) return;

    this.setState({ isDrawing: true }, () => {
      const ctx = this.canvasRef.current.getContext("2d");
      ctx.beginPath();
      ctx.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    });
  };

  draw = (e) => {
    if (!this.state.isDrawing) return;

    const ctx = this.canvasRef.current.getContext("2d");
    ctx.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctx.strokeStyle = "red";
    ctx.lineWidth = 2;
    ctx.stroke();
  };

  endDraw = () => {
    if (!this.state.drawMode) return;
    this.setState({ isDrawing: false });
  };

  clearCanvas = () => {
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  toggleDraw = () => {
    this.setState((prevState) => ({ drawMode: !prevState.drawMode }));
  };

  render() {
    const { dicomImageSrc } = this.props;
    const { drawMode } = this.state;

    return (
      <div className="col-lg-9 col-md-12">
        <div className="draw-controls mb-2">
          <button
            className="btn btn-primary btn-sm me-2"
            onClick={this.toggleDraw}
          >
            {drawMode ? "Disable Draw" : "Enable Draw"}
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={this.clearCanvas}
          >
            Clear Annotations
          </button>
        </div>

        <div id="dicomViewer" style={{ position: "relative" }}>
          <div
            ref={this.imageRef}
            id="dicomImage"
            src={dicomImageSrc}
            alt="DICOM Sample"
            style={{ width: "100%", display: "block" }}
          />
          <canvas
            ref={this.canvasRef}
            id="annotationCanvas"
            onMouseDown={this.startDraw}
            onMouseMove={this.draw}
            onMouseUp={this.endDraw}
            onMouseLeave={this.endDraw}
          />
        </div>
      </div>
    );
  }
}

export default DicomViewer;
